"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.defaultQuery = exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("reshow-runtime/helpers/toConsumableArray"));
var _winDoc = require("win-doc");
var _reshowConstant = require("reshow-constant");
//@ts-check

/**
 * @param {any} a
 * @returns {any[]}
 */
var arrayFrom = function arrayFrom(a) {
  return a ? (0, _toConsumableArray2["default"])(a) : [];
};

/**
 * @param {HTMLElement[]} all
 * @param {HTMLElement} el
 * @returns {HTMLElement}
 */
var findHit = function findHit(all, el) {
  var hit;

  /**
   * @param {HTMLElement} p
   */
  var setHit = function setHit(p) {
    return hit = p;
  };
  all.some(function (p) {
    return p.contains(el) && !p.isSameNode(el) ? setHit(p) : false;
  });
  return hit;
};

/**
 * @typedef {object} QueryUtil
 * @property {Function} all
 * @property {Function} ancestor
 * @property {Function} el
 * @property {Function} one
 */

/**
 * @param {any} base
 * @returns {QueryUtil}
 */
var queryFrom = function queryFrom(base) {
  if (!base) {
    return;
  }

  /**
   * @type {null|CallableFunction}
   */
  var myBase = _reshowConstant.FUNCTION === typeof base ? base : function () {
    return defaultQuery === null || defaultQuery === void 0 ? void 0 : defaultQuery.el(base);
  };

  /**
   * @param {string} sel
   * @returns {HTMLElement}
   */
  var queryOne = function queryOne(sel) {
    var _myBase;
    return (_myBase = myBase()) === null || _myBase === void 0 ? void 0 : _myBase.querySelector(sel);
  };

  /**
   * @param {string} sel
   * @returns {HTMLElement[]}
   */
  var _all = function _all(sel) {
    var _myBase2;
    return arrayFrom((_myBase2 = myBase()) === null || _myBase2 === void 0 ? void 0 : _myBase2.querySelectorAll(sel));
  };

  /**
   * @param {string|string[]} sel
   * @returns {HTMLElement[]}
   */
  var queryAll = function queryAll(sel) {
    return sel && (_reshowConstant.STRING === typeof sel ? _all( /** @type {string}*/sel) : /** @type {string[]}*/sel.reduce(
    /**
     * @param {HTMLElement[]} accumulator
     * @param {string} currentValue
     */
    function (accumulator, currentValue) {
      return accumulator.concat(_all(currentValue));
    }, []));
  };

  /**
   * @param {string|HTMLElement} el
   * @returns {HTMLElement}
   */
  var queryEl = function queryEl(el) {
    return _reshowConstant.STRING === typeof el ? queryOne( /** @type {string}*/el) : /** @type {HTMLElement}*/el;
  };

  /**
   * @param {HTMLElement} el
   * @param {string} ancestor
   * @returns {Element|boolean}
   */
  var _queryAncestorPolyfill = function _queryAncestorPolyfill(el, ancestor) {
    var lastHit;
    var hit;
    var all = _all(ancestor);
    if (all) {
      hit = findHit(all, el);
    }
    while (hit) {
      lastHit = hit;
      var _all2 = hit.querySelectorAll(ancestor);
      if (_all2) {
        hit = findHit(arrayFrom(_all2), el);
      } else {
        break;
      }
    }
    return lastHit;
  };

  /**
   * @param {HTMLElement} el
   * @param {string} ancestor
   * @returns {Element|boolean}
   */
  var queryAncestor = function queryAncestor(el, ancestor) {
    el = queryEl(el);
    if (!el) {
      console.warn("Element is empty.");
      return false;
    }
    return el.closest ? el.closest(ancestor) : _queryAncestorPolyfill(el, ancestor);
  };
  return {
    all: queryAll,
    ancestor: queryAncestor,
    el: queryEl,
    one: queryOne
  };
};
var defaultQuery = queryFrom(_winDoc.doc);
exports.defaultQuery = defaultQuery;
var _default = queryFrom;
exports["default"] = _default;